// Generated by scripts/sync-work-review-contracts.mjs. Do not edit by hand.
import { z } from 'zod';

const uuid = z.string().uuid();
const instant = z.string().datetime({ offset: true });
export const ownTimerCommandSchema = z.discriminatedUnion('action', [
  z
    .object({
      action: z.literal('start'),
      workOrderId: uuid,
      bookingServiceId: uuid.nullable().optional(),
      description: z.string().max(4096).optional(),
      laborRateCents: z.number().int().nonnegative().optional(),
    })
    .strict(),
  z.object({ action: z.literal('stop'), workOrderId: uuid, entryId: uuid }).strict(),
]);
export const ownTimerEntrySchema = z
  .object({
    id: uuid,
    bookingId: uuid,
    bookingServiceId: uuid.nullable(),
    startedAt: instant,
    endedAt: instant.nullable(),
    durationHours: z.string().nullable(),
    breakHours: z.string(),
    description: z.string().nullable(),
    billable: z.boolean(),
    laborRateCents: z.number().finite().nonnegative().nullable(),
    isActive: z.boolean(),
  })
  .strict();
export const ownTimerReviewSchema = z
  .object({
    command: ownTimerCommandSchema,
    revision: z.string().min(1),
    effects: z
      .object({
        entryId: uuid.nullable(),
        startedAt: instant.nullable(),
        bookingServiceId: uuid.nullable(),
        description: z.string().nullable(),
        breakHours: z.string(),
        billable: z.boolean(),
        laborRateCents: z.number().finite().nonnegative().nullable(),
        clock: z.enum(['start_on_execution', 'stop_on_execution']),
        duration: z.literal('canonical_net_at_stop'),
        lifecycle: z.literal('unchanged'),
      })
      .strict(),
  })
  .strict()
  .superRefine((v, ctx) => {
    const start = v.command.action === 'start';
    if (
      v.effects.clock !== (start ? 'start_on_execution' : 'stop_on_execution') ||
      (start
        ? v.effects.entryId !== null || v.effects.startedAt !== null
        : v.effects.entryId !== (v.command.action === 'stop' ? v.command.entryId : null) ||
          v.effects.startedAt === null)
    )
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Timer effect does not match command' });
  });
export const reviewedOwnTimerSchema = z
  .object({
    command: ownTimerCommandSchema,
    review: ownTimerReviewSchema,
  })
  .strict();
export const ownTimerOutcomeSchema = z
  .object({
    outcome: z.literal('applied'),
    action: z.enum(['start', 'stop']),
    workOrderId: uuid,
    entry: ownTimerEntrySchema,
  })
  .strict();
export type OwnTimerCommand = z.infer<typeof ownTimerCommandSchema>;
export type OwnTimerReview = z.infer<typeof ownTimerReviewSchema>;
export type OwnTimerEntry = z.infer<typeof ownTimerEntrySchema>;
